import { NextSeo, NextSeoProps } from 'next-seo';

import { SeoFragment } from 'types/api/dato-operations.types';

import { convertToNextSeoProps } from 'components/@seo/utils';

interface Props extends NextSeoProps {
  tags?: Array<SeoFragment>;
}
/**
 *
 * SEO overwrites per page.,
 * when you need custom SEO or additional JSON LD schema, create a custom SEO component.
 */
const PageSeo = ({ tags = [], ...props }: Props) => {
  return <NextSeo {...convertToNextSeoProps(tags)} {...props} />;
};

export default PageSeo;
